import React from 'react';
import { Star, ExternalLink } from 'lucide-react';
import { testimonials } from '../data/mock';

const videoTestimonials = [
  { id: 1, src: 'https://roseville-smile-revamp.lovable.app/videos/testimonial-1.mov' },
  { id: 2, src: 'https://roseville-smile-revamp.lovable.app/videos/testimonial-2.mov' },
  { id: 3, src: 'https://roseville-smile-revamp.lovable.app/videos/testimonial-3.mov' },
  { id: 4, src: 'https://roseville-smile-revamp.lovable.app/videos/testimonial-4.mov' },
];

const TestimonialCard = ({ testimonial }) => {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all duration-300">
      {/* Stars */}
      <div className="flex gap-1 mb-4">
        {[...Array(5)].map((_, i) => (
          <Star
            key={i}
            size={18}
            className={i < testimonial.rating ? 'text-amber-400 fill-amber-400' : 'text-gray-300'}
          />
        ))}
      </div>
      
      {/* Quote */}
      <p className="text-gray-700 leading-relaxed mb-4 italic">
        &ldquo;{testimonial.text}&rdquo;
      </p>
      
      {/* Author */}
      <p className="text-gray-900 font-semibold">
        - {testimonial.name}
      </p>
    </div>
  );
};

const TestimonialsSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Patient Testimonials
          </h2>
          <p className="text-gray-600 text-lg mb-6">
            See what our patients have to say about their experience
          </p>
          <a
            href="https://www.google.com/maps/search/?api=1&query=Sunshine+Dental+Care+700+Sunrise+Ave+Roseville+CA+95661"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-cyan-600 hover:text-cyan-700 font-medium"
          >
            <span>Read All Reviews on Google</span>
            <ExternalLink size={16} />
          </a>
        </div>

        {/* Video Testimonials Section */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 text-center mb-8">
            Video Testimonials
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {videoTestimonials.map((video) => (
              <div
                key={video.id}
                className="rounded-2xl overflow-hidden shadow-lg border border-gray-200 bg-gray-50"
              >
                <video
                  controls
                  playsInline
                  controlsList="nodownload"
                  className="w-full h-auto bg-gray-100"
                  preload="metadata"
                >
                  <source src={video.src} type="video/mp4" />
                  <source src={video.src} type="video/quicktime" />
                  Your browser does not support the video tag.
                </video>
              </div>
            ))}
          </div>
        </div>

        {/* Written Testimonials */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial) => (
            <TestimonialCard key={testimonial.id} testimonial={testimonial} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
